import {ApiClient} from "../generated/ApiClient";
import {Aborted, useFetcher} from "./useFetcher";
import {ResponseError} from "../generated";
import {isSongPlay} from "../utils/isSongPlay";

export const useNowSongKey = (radioSlug:string) => ({
    queryKey: ["useNowSongKey", radioSlug, `song-${radioSlug}`],
    refetchOnMount: false,
    queryFn: useFetcher(() => {
        return new ApiClient().getApiRadioSongNow({ slug: radioSlug },{
            credentials: "include",
            signal: Aborted().signal
        }).catch(e => {
            return null;
        }).then(x => {
            if (isSongPlay((x)))
                return x;
            return null;
        })
    })
});

